'use strict';
var schema_1 = require("../schema");
module.exports = new schema_1.Schema({
    explicit: [
        require('../type/str'),
        require('../type/seq'),
        require('../type/map')
    ]
});
//# sourceMappingURL=failsafe.js.map